import { createFileRoute, redirect } from "@tanstack/react-router";

// A v2 virou a página principal; o link antigo leva para ela.
export const Route = createFileRoute("/certificacao-quadril-v2")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: "/certificacao-quadril" + (location.searchStr ?? ""), statusCode: 301 });
  },
});
